import { FC,memo } from "react";
import PharmacyTableRow from "./pharmacyTableRow";
import { sp_treatments_data } from "src/pages/actionDashboard/types";

type Props = {
  data: sp_treatments_data[];
  refreshListing: () => void;
};
const PharmacyTableBody: FC<Props> = ({
  data,
  refreshListing
}) => {
  return (
    <tbody>
    {data && data.length>0 && data.map((data: sp_treatments_data, index: number) => (
      <PharmacyTableRow
        data={data}
        refreshListing={refreshListing}
      />
    ))}
  </tbody>
  )
  
}

export default memo(PharmacyTableBody);
